













































































































import { defineComponent, onMounted, ref, watch } from '@vue/composition-api';
import { Table, TableColumn, Pagination } from 'element-ui';
import moment from 'moment';

import valueToLabel from '@utils/valueToLabel';

export default defineComponent({
  props: {
    selection: {
      type: Boolean,
      default: false,
    },
    selectable: {
      type: Function,
      default: () => {},
    },
    getRowKey: {
      type: Function,
      default: (row: any) => {
        return row.id;
      },
    },
    handleSelectionChange: {
      type: Function,
      default: () => {},
    },
    actionText: {
      type: String,
      default: '',
    },
    showPagination: {
      type: Boolean,
      default: true,
    },
    total: {
      type: Number,
      default: 0,
    },
    pageChange: {
      type: Function,
      default: () => {},
    },
    currentPage: {
      type: Number,
      default: 1,
    },
    pageSize: {
      type: Number,
      default: 10,
    },
    data: {
      type: Object,
      default: () => [],
    },
  },
  components: {
    't-table': Table,
    't-table-column': TableColumn,
    't-pagination': Pagination,
  },
  setup(prop: any, { emit }) {
    const tableData = ref([]);
    const current = ref(1);
    const size = ref(10);
    const pageSizeArr = ref([5, 10, 20, 50, 100]);
    const column: any = ref([]);
    const opColumn: any = ref(null);

    const sortChange = (sortable) => {
      const { order, prop } = sortable;
      tableData.value.sort((a: any, b: any): any => {
        const flag = moment(a[prop]).valueOf() > moment(b[prop]).valueOf();

        return order === 'descending' ? !flag : flag;
      });

      emit('changeTableData', [...tableData.value]);
    };

    watch(
      () => prop.currentPage,
      (val: any) => {
        console.log('changePaginationInfo >>>>>>>>> val : ', val);
        current.value = val;
      },
    );

    watch(
      () => prop.pageSize,
      (val: any) => {
        console.log('changePaginationInfo >>>>>>>>> val : ', val);
        size.value = val;
      },
    );

    const handleSizeChange = (pageSize: number) => {
      console.log(
        '切换每页显示多少 handleSizeChange >>>>>>>>> pageSize : ',
        pageSize,
      );
      size.value = pageSize;
      prop.pageChange(current.value, pageSize);
    };

    const handleCurrentChange = (currentPage: number, reset = false) => {
      console.log(
        '切换页码 handleCurrentChange >>>>>>>>> currentPage : ',
        currentPage,
      );
      console.log('切换页码 handleCurrentChange >>>>>>>>> reset : ', reset);
      current.value = currentPage;
      if (!reset) {
        prop.pageChange(currentPage, size.value);
      }
    };

    const updateTable = (val: any) => {
      opColumn.value = val.column.find(i=>i.operate);
      column.value = val.column.filter(i=>!i.operate);
      
      if (val.data?.length) {
        tableData.value = val.data;
      } else {
        tableData.value = [];
      }
    };

    watch(
      () => prop.data,
      (val: any) => {
        updateTable(val);
      },
      { deep: true, immediate: true },
    );

    const ininPage = () => {
      current.value = prop.currentPage ? prop.currentPage : 1;
      size.value = prop.pageSize ? prop.pageSize : 10;
    };

    // const getRowKey = (row: any) => {
    //   return row.id;
    // };

    onMounted(ininPage);

    return {
      tableData,
      column,
      opColumn,
      sortChange,
      current,
      size,
      pageSizeArr,
      handleSizeChange,
      handleCurrentChange,
      valueToLabel,
    };
  },
});
